import Header from "./HubungiKami/Header";
import React from "react";
import WhistleBlowingSection from "./HubungiKami/WhistleBlowingSection";
import Content from "./HubungiKami/Content";

function Index() {
    return (
        <div>
            <div className="my-16 hero-bg-hubungi-kami">
                <Header/>
                <div className="max-w-screen-2xl flex flex-col mx-auto">
                    <Content/>
                    <WhistleBlowingSection/>
                </div>
            </div>
        </div>
    );
}

export default Index;
